// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditPopup_deleteButton__2bnCN","field":"EditPopup_field__3cqFX","text":"EditPopup_text__FHdW2"};